import palette from '../theme/palette';
import typography from '../theme/typography';
import { ComponentsOverrides, CSSInterpolation } from '@mui/material/styles';

const styleOverrides: ComponentsOverrides['MuiAlert'] & { filledNeutral?: CSSInterpolation } = {
  root: {
    fontSize: '14px',
    fontWeight: typography.fontWeightRegular,
    '& *, & .MuiLink-root': {
      color: 'inherit',
      borderBottomColor: 'inherit',
    },
    "& .MuiAlert-action svg": {
      width: '28px',
      height: '28px'
    },
    borderRadius: 0,
  },
  filledSuccess: {
    color: palette.text.primary,
  },
  filledWarning: {
    color: palette.text.primary,
  },
  filledError: {
    color: palette.common.white,
  },
  filledInfo: {
    color: palette.common.white,
    backgroundColor: palette.secondary.main,
  },
  filledNeutral: {
    color: palette.text.primary,
    backgroundColor: palette.background.default,
  }
};

export default styleOverrides;
